import { FC } from 'react';
import { Logo } from 'enova-frontend-components';

import styles from './maintenance.module.css';

// Static header component
const MaintenanceHeader: FC = () => {
  return (
    <header className={styles['maintenance-header']}>
      <div className={styles['maintenance-header-content']}>
        <div className={styles['maintenance-logo']}>
          <Logo title="Enova" className="logo" />
          <span className={styles['maintenance-logo-text']}>| ENERGIMERKE</span>
        </div>
      </div>
    </header>
  );
};

// Static footer component
const MaintenanceFooter: FC = () => {
  return (
    <footer className={styles['maintenance-footer']}>
      <div className={styles['maintenance-footer-content']}>
        <div className={styles['maintenance-footer-section']}>
          <h3>Snarveier</h3>
          <a href="https://www.enova.no/energimerking/" target="_blank" rel="noopener noreferrer">
            Om Energimerkeordningen
          </a>
          <a href="https://www.enova.no/energimerking/bolig/" target="_blank" rel="noopener noreferrer">
            Veiledning
          </a>
          <a href="https://www.enova.no/privat/alle-energitiltak/" target="_blank" rel="noopener noreferrer">
            Støtteordninger
          </a>
        </div>

        <div className={styles['maintenance-footer-section']}>
          <h3>Hjelp</h3>
          <a href="https://www.enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/enova-og-personvern/cookies" target="_blank" rel="noopener noreferrer">
            Personvern og informasjonskapsler
          </a>
          <a href="mailto:nettredaktor@enova.no">
            Send tilbakemelding på nettstedet
          </a>
        </div>

        <div className={styles['maintenance-footer-section']}>
          <h3>Kontakt oss</h3>
          <a href="https://www.enova.no/om-enova/kontakt-oss/" target="_blank" rel="noopener noreferrer">
            Kontakt oss
          </a>
        </div>

        <div className={styles['maintenance-footer-logo']}>
          <Logo title="Enova" className="logo" />
          <span className={styles['maintenance-footer-logo-text']}>| ENERGIMERKE</span>
        </div>
      </div>
    </footer>
  );
};

// Main maintenance screen component
const MaintenanceScreen: FC = () => {
  // Get language from config or default to Norwegian
  const lang = (window.config?.VITE_LANG || 'nb-NO').toLowerCase();
  const messages = {
    'nb-no': {
      title: 'System under vedlikehold',
      message: 'I forbindelse med endringer av energiattesten etter ny forskrift vil energimerkesystemet være utilgjengelig i perioden 31.12.2025 - 07.01.2026.',
      apology: ''
    },
    'nn-no': {
      title: 'System under vedlikehald',
      message: 'Systemet er for augeblikket utilgjengelig på grunn av vedlikehald.',
      apology: 'Vi beklager ulempene og jobbar med å få systemet tilbake så snart som mogleg.'
    },
    'en': {
      title: 'System Under Maintenance',
      message: 'The system is currently unavailable due to maintenance.',
      apology: 'We apologize for the inconvenience and are working to restore the system as soon as possible.'
    }
  };

  const content = messages[lang as keyof typeof messages] || messages['nb-no'];

  return (
    <div className={styles['maintenance-container']}>
      <MaintenanceHeader />
      <main className={styles['maintenance-main']}>
        <div className={styles['maintenance-content']}>
          <div className={styles['maintenance-icon']}>🔧</div>
          <h1 className={styles['maintenance-title']}>{content.title}</h1>
          <p className={styles['maintenance-message']}>{content.message}</p>
          <p className={styles['maintenance-apology']}>{content.apology}</p>
        </div>
      </main>

      <MaintenanceFooter />
    </div>
  );
};

export default MaintenanceScreen;
